import React from 'react'
import Link from 'gatsby-link'
import { css } from 'emotion'

const primary = '#00B386'
const secondary = '#FBBD08'
const nav = '#232323'

const ButtonClass = css`
  display: inline-block;
  padding: 1rem 2rem;
  border-radius: 4px;
  background-color: ${primary};
  color: #fff;
  transition: .2s ease-out;
  font-weight: 400;
  font-size: .8rem;

  @media (min-width: 800px) {
		font-size: 1rem;
  }

  &:hover {
    background-color: rgba(0, 179, 134, 0.7);
  }
`

const FlatClass = css`
  background-color: #fff;
  color: #232323;
  border: .1rem solid ${primary};
  padding: .9rem 1rem;
`

const AnchorBaseClass = css`
  display: inline-block;
  padding: 1rem 2rem;
  transition: .2s ease-out;
  color: ${primary};
  font-weight: 300;
  border-radius: 4px;
  @media (min-width: 800px) {
		width: initial;
  }

  &:hover {
    background-color: rgba(158, 158, 158, 0.2);
  }
`

const HorizontalPaddingClass = css`
  padding: 0.9rem 3rem;
`

const SecondaryAnchor = css`
  color: ${secondary};
`

const SecondaryButton = css`
  background-color: ${secondary};
  color: #fff;
`

const NavLinkClass = css`
  color: ${nav};
  font-size: 1.1rem;
  padding: 1rem;
  margin: 0 0.2rem;
`

const MobileLinkClass = css`
  display: block;
`

const IconClass = css`
  color: #00b386;
  opacity: 0;
`

const WrapperIconClass = css`
  display: flex !important;
  justify-content: space-between;

  &:hover {
    opacity: 1;
  }
`

const BigButtonClass = css`
  background-color: #00B386;
  color: white;
  &:hover {
    background-color: rgba(0,179,134,0.7);
  }
`

const Button = (props) => {
  const SecondaryClass = props.anchor ? SecondaryAnchor : SecondaryButton
  const styles = `
    ${props.anchor ? AnchorBaseClass : ButtonClass} 
    ${props.flat ? FlatClass : ''} 
    ${props.secondary ? SecondaryClass : ''}
    ${props.navLink ? NavLinkClass : ''}
    ${props.mobile ? MobileLinkClass : ''}
    ${props.icon ? WrapperIconClass : ''}
    ${props.button ? BigButtonClass : ''}
    ${props.horizontalPadding ? HorizontalPaddingClass : ''}
  `

  if (props.external) {
    return (
      <a href={props.to} className={`${styles} ${props.style || ''} ${props.className || ''}`} onClick={props.onClick} style={props.styles}>
        {props.children}
        {props.icon ? (
          <i className={`${IconClass} material-icons`}>{props.icon}</i>
        ): null}
      </a>
    )
  } else {
    return (
      <Link to={props.to || ''} className={`${styles} ${props.style || ''} ${props.className || ''}`} onClick={props.onClick}>
        {props.children}
        {props.icon ? (
          <i className={`${IconClass} material-icons`}>{props.icon}</i>
        ): null}
      </Link>
    )
  }
}
 
export default Button;


// WEBPACK FOOTER //
// ./src/components/buttons/Button.js